<template>
    <div class="view-wrapper">
        <router-view></router-view>
    </div>
</template>
<script>
    export default {
        data: function() {
            return {
                msg: null
            };
        },
        created() {
            let route = this.$route;
            this.msg = `Current Route Name is "${route.name}"`;
        }
    };
</script>
<style lang="postcss" scoped type="text/postcss">
.view-wrapper {
  width: 100%;
  height: 100%;
}
</style>





// WEBPACK FOOTER //
// view-wrapper.vue?332ce1a6